import React from 'react';
import Button from '../ui/Button';
import EmptyState from '../ui/EmptyState';
import Pill from '../ui/Pill';

const TONE_TO_PILL_VARIANT = {
  warning: 'warning',
  info: 'info',
  danger: 'danger',
  neutral: 'neutral',
};

function ActionBriefingItem({ count, label, tone, onNavigate, path }) {
  if (!count) return null;
  const variant = TONE_TO_PILL_VARIANT[tone] || 'neutral';
  return (
    <div className="action-briefing-item" data-tone={tone || 'neutral'}>
      <Pill variant={variant} className="action-briefing-item__count">
        {count}
      </Pill>
      <span className="action-briefing-item__label">{label}</span>
      {onNavigate && path ? (
        <Button
          size="sm"
          variant="secondary"
          onClick={() => onNavigate(path)}
          className="action-briefing-item__cta"
        >
          Review
        </Button>
      ) : null}
    </div>
  );
}

function ActionBriefing({ items = [], heading = 'Open action items' }) {
  const visibleItems = items.filter(item => item.count > 0);
  if (!visibleItems.length) {
    return (
      <div className="action-briefing action-briefing-clear">
        <EmptyState
          compact
          icon="✓"
          headline="No action items right now"
          body="Nothing new needs your attention."
          className="action-briefing-empty"
        />
      </div>
    );
  }

  return (
    <div className="action-briefing">
      <span className="action-briefing-heading">{heading}</span>
      <div className="action-briefing-items">
        {visibleItems.map((item) => (
          <ActionBriefingItem key={item.label} {...item} />
        ))}
      </div>
    </div>
  );
}

export default ActionBriefing;
